import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=64dc4c8b"
var script = {}


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports